import { createContext, useContext, useState } from "react";

const QuizDataContext = createContext({
    isAppTrial: false,
    variationName: "",
    area: "",
});

export const QuizDataContextProvider = ({ children, isAppTrial, variationName, area }) => {
    return (
        <QuizDataContext.Provider value={{ isAppTrial, variationName, area }}>
            {children}
        </QuizDataContext.Provider>
    );
}

export const useQuizDataContext = () => {
    const context = useContext(QuizDataContext);
    if (!context) {
        throw new Error('useQuizDataContext must be used within a QuizDataContextProvider');
    }

    return context;
}